import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { URL_ADMIN} from "constants/UrlConstant";

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);
      
  return token ? <Navigate to={AUTHENTICATED_ENTRY + URL_ADMIN} /> : <Outlet />;
};

export default PublicRoute;
